/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  ErrorResponse,
  EventCreateRequest,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  Quotation,
  QuotationResponse,
  SearchQuotationsRequest,
  SearchQuotationsResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    QuotationFromJSON,
    QuotationToJSON,
    QuotationResponseFromJSON,
    QuotationResponseToJSON,
    SearchQuotationsRequestFromJSON,
    SearchQuotationsRequestToJSON,
    SearchQuotationsResponseFromJSON,
    SearchQuotationsResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnQuotationByIdRequest {
    quotationId: string;
    contentType: CreateChangeRequestOnQuotationByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnQuotationByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateQuotationRequest {
    contentType: CreateQuotationContentTypeEnum;
    xBOLMemberIdentifier: string;
    quotation: Quotation;
    id?: string;
    source?: boolean;
    accept?: CreateQuotationAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateQuotationEventRequest {
    quotationId: string;
    contentType: CreateQuotationEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateQuotationEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteQuotationACLAuthorizationByMemberIdRequest {
    quotationId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteQuotationByIdRequest {
    quotationId: string;
    traceparent?: string;
}

export interface DeleteQuotationEventByIdRequest {
    quotationId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnQuotationByIdRequest {
    quotationId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnQuotationByIdAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationACLAuthorizationByMemberIdRequest {
    quotationId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetQuotationACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationACLByIdRequest {
    quotationId: string;
    at?: string;
    revision?: string;
    accept?: GetQuotationACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationByIdRequest {
    quotationId: string;
    at?: string;
    revision?: string;
    accept?: GetQuotationByIdAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationEventsRequest {
    quotationId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetQuotationEventsAcceptEnum;
    traceparent?: string;
}

export interface GetQuotationMetadataByIdRequest {
    quotationId: string;
    accept?: GetQuotationMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfQuotationByIdRequest {
    quotationId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfQuotationByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchQuotationByIdRequest {
    quotationId: string;
    contentType: PatchQuotationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    quotation: Quotation;
    revision?: string;
    accept?: PatchQuotationByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchQuotationGetRequest {
    id?: string;
    searchBody?: SearchQuotationsRequest;
    accept?: SearchQuotationGetAcceptEnum;
    traceparent?: string;
}

export interface SearchQuotationsPostRequest {
    contentType: SearchQuotationsPostContentTypeEnum;
    searchQuotationsRequest: SearchQuotationsRequest;
    limit?: number;
    offset?: number;
    accept?: SearchQuotationsPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnQuotationByIdRequest {
    quotationId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnQuotationByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnQuotationByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateQuotationByIdRequest {
    quotationId: string;
    contentType: UpdateQuotationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    quotation: Quotation;
    revision?: string;
    accept?: UpdateQuotationByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertQuotationACLAuthorizationByIdRequest {
    quotationId: string;
    contentType: UpsertQuotationACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertQuotationACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsQuotationsApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific Quotation resource, identified by its `QuotationId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the Quotation resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a Quotation resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the Quotation resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a Quotation
     */
    async createChangeRequestOnQuotationByIdRaw(requestParameters: CreateChangeRequestOnQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling createChangeRequestOnQuotationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnQuotationById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnQuotationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/change-requests`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific Quotation resource, identified by its `QuotationId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the Quotation resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a Quotation resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the Quotation resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a Quotation
     */
    async createChangeRequestOnQuotationById(requestParameters: CreateChangeRequestOnQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnQuotationByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new Quotation.  When creating a Quotation, the value of the header `X-BOL-Member-Identifier` defines the Quotation\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a Quotation, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the Quotation and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the Quotation, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the Quotation.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a Quotation
     */
    async createQuotationRaw(requestParameters: CreateQuotationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuotationResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createQuotation().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createQuotation().'
            );
        }

        if (requestParameters['quotation'] == null) {
            throw new runtime.RequiredError(
                'quotation',
                'Required parameter "quotation" was null or undefined when calling createQuotation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuotationToJSON(requestParameters['quotation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuotationResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new Quotation.  When creating a Quotation, the value of the header `X-BOL-Member-Identifier` defines the Quotation\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a Quotation, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the Quotation and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the Quotation, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the Quotation.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a Quotation
     */
    async createQuotation(requestParameters: CreateQuotationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuotationResponse | null | undefined > {
        const response = await this.createQuotationRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a Quotation by `quotationId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a Quotation resource. 
     * Create an Event of a Quotation
     */
    async createQuotationEventRaw(requestParameters: CreateQuotationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling createQuotationEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createQuotationEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createQuotationEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createQuotationEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/events`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a Quotation by `quotationId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a Quotation resource. 
     * Create an Event of a Quotation
     */
    async createQuotationEvent(requestParameters: CreateQuotationEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createQuotationEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a Quotation resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the Quotation resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a Quotation resource. 
     * Delete an authorization of an access control list of a Quotation by memberId
     */
    async deleteQuotationACLAuthorizationByMemberIdRaw(requestParameters: DeleteQuotationACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling deleteQuotationACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteQuotationACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteQuotationACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a Quotation resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the Quotation resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a Quotation resource. 
     * Delete an authorization of an access control list of a Quotation by memberId
     */
    async deleteQuotationACLAuthorizationByMemberId(requestParameters: DeleteQuotationACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuotationACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific Quotation resource, identified by its `QuotationId`.  - When a Quotation is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a Quotation resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a Quotation resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a Quotation resource. 
     * Delete a Quotation by quotationId
     */
    async deleteQuotationByIdRaw(requestParameters: DeleteQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling deleteQuotationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific Quotation resource, identified by its `QuotationId`.  - When a Quotation is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a Quotation resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a Quotation resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a Quotation resource. 
     * Delete a Quotation by quotationId
     */
    async deleteQuotationById(requestParameters: DeleteQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuotationByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a Quotation resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a Quotation resource. 
     * Delete an event of a Quotation by id
     */
    async deleteQuotationEventByIdRaw(requestParameters: DeleteQuotationEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling deleteQuotationEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteQuotationEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteQuotationEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a Quotation resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a Quotation resource. 
     * Delete an event of a Quotation by id
     */
    async deleteQuotationEventById(requestParameters: DeleteQuotationEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuotationEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given Quotation, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the Quotation resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a Quotation by changeRequestId
     */
    async getChangeRequestOnQuotationByIdRaw(requestParameters: GetChangeRequestOnQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling getChangeRequestOnQuotationById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnQuotationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given Quotation, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the Quotation resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a Quotation by changeRequestId
     */
    async getChangeRequestOnQuotationById(requestParameters: GetChangeRequestOnQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnQuotationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a Quotation resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a Quotation resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a Quotation by memberId
     */
    async getQuotationACLAuthorizationByMemberIdRaw(requestParameters: GetQuotationACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling getQuotationACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getQuotationACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a Quotation resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a Quotation resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a Quotation by memberId
     */
    async getQuotationACLAuthorizationByMemberId(requestParameters: GetQuotationACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getQuotationACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific Quotation resource, identified by its `QuotationId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the Quotation and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a Quotation resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a Quotation for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getQuotationACLByIdRaw(requestParameters: GetQuotationACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling getQuotationACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/acl`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific Quotation resource, identified by its `QuotationId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the Quotation and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a Quotation resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a Quotation for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getQuotationACLById(requestParameters: GetQuotationACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getQuotationACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific Quotation by its `QuotationId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this Quotation resource. 
     * Get a Quotation by quotationId
     */
    async getQuotationByIdRaw(requestParameters: GetQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuotationResponse>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling getQuotationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuotationResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific Quotation by its `QuotationId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this Quotation resource. 
     * Get a Quotation by quotationId
     */
    async getQuotationById(requestParameters: GetQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuotationResponse> {
        const response = await this.getQuotationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a Quotation by `quotationId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a Quotation resource. 
     * List Events of a Quotation
     */
    async getQuotationEventsRaw(requestParameters: GetQuotationEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling getQuotationEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/events`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a Quotation by `quotationId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a Quotation resource. 
     * List Events of a Quotation
     */
    async getQuotationEvents(requestParameters: GetQuotationEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getQuotationEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific Quotation by its `QuotationId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a Quotation metadata by quotationId
     */
    async getQuotationMetadataByIdRaw(requestParameters: GetQuotationMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling getQuotationMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/metadata`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific Quotation by its `QuotationId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a Quotation metadata by quotationId
     */
    async getQuotationMetadataById(requestParameters: GetQuotationMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getQuotationMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified Quotation, identified by its `QuotationId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given Quotation resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a Quotation resource. 
     * Get a list of ChangeRequest for Quotation
     */
    async listChangeRequestsOfQuotationByIdRaw(requestParameters: ListChangeRequestsOfQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling listChangeRequestsOfQuotationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/change-requests`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified Quotation, identified by its `QuotationId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given Quotation resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a Quotation resource. 
     * Get a list of ChangeRequest for Quotation
     */
    async listChangeRequestsOfQuotationById(requestParameters: ListChangeRequestsOfQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfQuotationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing Quotation identified by its `QuotationId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Quotation resource. 
     * Partially update a Quotation by applying a JSON Merge Patch change request
     */
    async patchQuotationByIdRaw(requestParameters: PatchQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuotationResponse>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling patchQuotationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchQuotationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchQuotationById().'
            );
        }

        if (requestParameters['quotation'] == null) {
            throw new runtime.RequiredError(
                'quotation',
                'Required parameter "quotation" was null or undefined when calling patchQuotationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: QuotationToJSON(requestParameters['quotation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuotationResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing Quotation identified by its `QuotationId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Quotation resource. 
     * Partially update a Quotation by applying a JSON Merge Patch change request
     */
    async patchQuotationById(requestParameters: PatchQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuotationResponse> {
        const response = await this.patchQuotationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of Quotation resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Quotations.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Quotation resources. 
     * Search for Quotations
     */
    async searchQuotationGetRaw(requestParameters: SearchQuotationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchQuotationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchQuotationsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of Quotation resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Quotations.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Quotation resources. 
     * Search for Quotations
     */
    async searchQuotationGet(requestParameters: SearchQuotationGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchQuotationsResponse> {
        const response = await this.searchQuotationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of Quotation resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Quotations.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Quotation resources. 
     * Search for Quotations
     */
    async searchQuotationsPostRaw(requestParameters: SearchQuotationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchQuotationsResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchQuotationsPost().'
            );
        }

        if (requestParameters['searchQuotationsRequest'] == null) {
            throw new runtime.RequiredError(
                'searchQuotationsRequest',
                'Required parameter "searchQuotationsRequest" was null or undefined when calling searchQuotationsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchQuotationsRequestToJSON(requestParameters['searchQuotationsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchQuotationsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of Quotation resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Quotations.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Quotation resources. 
     * Search for Quotations
     */
    async searchQuotationsPost(requestParameters: SearchQuotationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchQuotationsResponse> {
        const response = await this.searchQuotationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given Quotation, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a Quotation resource. 
     * Accept or reject a ChangeRequest on a  Quotation using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnQuotationByIdRaw(requestParameters: UpdateChangeRequestOnQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling updateChangeRequestOnQuotationById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnQuotationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnQuotationById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnQuotationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given Quotation, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a Quotation resource. 
     * Accept or reject a ChangeRequest on a  Quotation using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnQuotationById(requestParameters: UpdateChangeRequestOnQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnQuotationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing Quotation identified by its `QuotationId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Quotation resource. 
     * Update an existing Quotation by creating and applying a change request
     */
    async updateQuotationByIdRaw(requestParameters: UpdateQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QuotationResponse>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling updateQuotationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateQuotationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateQuotationById().'
            );
        }

        if (requestParameters['quotation'] == null) {
            throw new runtime.RequiredError(
                'quotation',
                'Required parameter "quotation" was null or undefined when calling updateQuotationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuotationToJSON(requestParameters['quotation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QuotationResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing Quotation identified by its `QuotationId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Quotation resource. 
     * Update an existing Quotation by creating and applying a change request
     */
    async updateQuotationById(requestParameters: UpdateQuotationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QuotationResponse> {
        const response = await this.updateQuotationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific Quotation resource, identified by its `QuotationId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a Quotation resource. 
     * Upsert (create or update) an authorization of an access control list of a Quotation.
     */
    async upsertQuotationACLAuthorizationByIdRaw(requestParameters: UpsertQuotationACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['quotationId'] == null) {
            throw new runtime.RequiredError(
                'quotationId',
                'Required parameter "quotationId" was null or undefined when calling upsertQuotationACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertQuotationACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertQuotationACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/quotations/{quotationId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"quotationId"}}`, encodeURIComponent(String(requestParameters['quotationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific Quotation resource, identified by its `QuotationId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a Quotation resource. 
     * Upsert (create or update) an authorization of an access control list of a Quotation.
     */
    async upsertQuotationACLAuthorizationById(requestParameters: UpsertQuotationACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertQuotationACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnQuotationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnQuotationByIdContentTypeEnum = typeof CreateChangeRequestOnQuotationByIdContentTypeEnum[keyof typeof CreateChangeRequestOnQuotationByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnQuotationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnQuotationByIdAcceptEnum = typeof CreateChangeRequestOnQuotationByIdAcceptEnum[keyof typeof CreateChangeRequestOnQuotationByIdAcceptEnum];
/**
 * @export
 */
export const CreateQuotationContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateQuotationContentTypeEnum = typeof CreateQuotationContentTypeEnum[keyof typeof CreateQuotationContentTypeEnum];
/**
 * @export
 */
export const CreateQuotationAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateQuotationAcceptEnum = typeof CreateQuotationAcceptEnum[keyof typeof CreateQuotationAcceptEnum];
/**
 * @export
 */
export const CreateQuotationEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateQuotationEventContentTypeEnum = typeof CreateQuotationEventContentTypeEnum[keyof typeof CreateQuotationEventContentTypeEnum];
/**
 * @export
 */
export const CreateQuotationEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateQuotationEventAcceptEnum = typeof CreateQuotationEventAcceptEnum[keyof typeof CreateQuotationEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnQuotationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnQuotationByIdAcceptEnum = typeof GetChangeRequestOnQuotationByIdAcceptEnum[keyof typeof GetChangeRequestOnQuotationByIdAcceptEnum];
/**
 * @export
 */
export const GetQuotationACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationACLAuthorizationByMemberIdAcceptEnum = typeof GetQuotationACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetQuotationACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetQuotationACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationACLByIdAcceptEnum = typeof GetQuotationACLByIdAcceptEnum[keyof typeof GetQuotationACLByIdAcceptEnum];
/**
 * @export
 */
export const GetQuotationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationByIdAcceptEnum = typeof GetQuotationByIdAcceptEnum[keyof typeof GetQuotationByIdAcceptEnum];
/**
 * @export
 */
export const GetQuotationEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationEventsAcceptEnum = typeof GetQuotationEventsAcceptEnum[keyof typeof GetQuotationEventsAcceptEnum];
/**
 * @export
 */
export const GetQuotationMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetQuotationMetadataByIdAcceptEnum = typeof GetQuotationMetadataByIdAcceptEnum[keyof typeof GetQuotationMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfQuotationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfQuotationByIdAcceptEnum = typeof ListChangeRequestsOfQuotationByIdAcceptEnum[keyof typeof ListChangeRequestsOfQuotationByIdAcceptEnum];
/**
 * @export
 */
export const PatchQuotationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchQuotationByIdContentTypeEnum = typeof PatchQuotationByIdContentTypeEnum[keyof typeof PatchQuotationByIdContentTypeEnum];
/**
 * @export
 */
export const PatchQuotationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchQuotationByIdAcceptEnum = typeof PatchQuotationByIdAcceptEnum[keyof typeof PatchQuotationByIdAcceptEnum];
/**
 * @export
 */
export const SearchQuotationGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchQuotationGetAcceptEnum = typeof SearchQuotationGetAcceptEnum[keyof typeof SearchQuotationGetAcceptEnum];
/**
 * @export
 */
export const SearchQuotationsPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchQuotationsPostContentTypeEnum = typeof SearchQuotationsPostContentTypeEnum[keyof typeof SearchQuotationsPostContentTypeEnum];
/**
 * @export
 */
export const SearchQuotationsPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchQuotationsPostAcceptEnum = typeof SearchQuotationsPostAcceptEnum[keyof typeof SearchQuotationsPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnQuotationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnQuotationByIdContentTypeEnum = typeof UpdateChangeRequestOnQuotationByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnQuotationByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnQuotationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnQuotationByIdAcceptEnum = typeof UpdateChangeRequestOnQuotationByIdAcceptEnum[keyof typeof UpdateChangeRequestOnQuotationByIdAcceptEnum];
/**
 * @export
 */
export const UpdateQuotationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateQuotationByIdContentTypeEnum = typeof UpdateQuotationByIdContentTypeEnum[keyof typeof UpdateQuotationByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateQuotationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateQuotationByIdAcceptEnum = typeof UpdateQuotationByIdAcceptEnum[keyof typeof UpdateQuotationByIdAcceptEnum];
/**
 * @export
 */
export const UpsertQuotationACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertQuotationACLAuthorizationByIdContentTypeEnum = typeof UpsertQuotationACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertQuotationACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertQuotationACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertQuotationACLAuthorizationByIdAcceptEnum = typeof UpsertQuotationACLAuthorizationByIdAcceptEnum[keyof typeof UpsertQuotationACLAuthorizationByIdAcceptEnum];
